import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../components/common/HeroSection';
import SectionTitle from '../components/common/SectionTitle';
import services from '../data/services';

const Services = () => {
  return (
    <div className="services-page">
      <HeroSection 
        title="Our Services"
        breadcrumb={[{ name: 'Services' }]}
        background="/assets/images/about/bg.png"
      />
      
      <section className="py-16">
        <div className="container mx-auto px-4">
          <SectionTitle 
            subtitle="What We Offer"
            title="Comprehensive IT Services for Your Business"
            className="mb-12"
          />
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <div key={service.id} className="bg-white shadow-lg rounded-lg overflow-hidden transition-transform duration-300 hover:-translate-y-2">
                <div className="h-48 bg-blue-100 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500"
                  />
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-800">
                    <Link to={service.route} className="hover:text-blue-600 transition-colors">
                      {service.title}
                    </Link>
                  </h3>
                  
                  <p className="text-gray-600 mb-4">
                    {service.shortDescription.length > 150 
                      ? `${service.shortDescription.substring(0, 150)}...` 
                      : service.shortDescription
                    }
                  </p>
                  
                  <Link 
                    to={service.route} 
                    className="text-blue-600 font-medium inline-flex items-center hover:text-blue-800 transition-colors"
                  >
                    Read More 
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      className="h-4 w-4 ml-1" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M9 5l7 7-7 7" 
                      />
                    </svg>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;